import { render, staticRenderFns } from "./OwnSales.vue?vue&type=template&id=0617c0e3&scoped=true"
import script from "./OwnSales.vue?vue&type=script&lang=js"
export * from "./OwnSales.vue?vue&type=script&lang=js"
import style0 from "./OwnSales.vue?vue&type=style&index=0&id=0617c0e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617c0e3",
  null
  
)

export default component.exports